
import React, { createContext, ReactNode, useContext, useState } from 'react'

import OptionsDialog from '../Components/OptionsDialog/OptionsDialog'

export interface OptionsDialogOptions {
  icon: string | JSX.Element,
  label: string,
  color?: string,
  onClick: () => void
}

interface OptionsDialogProps {
  isOpen: boolean,
  show: (title: string, options: OptionsDialogOptions[]) => void,
  hide: () => void,
}

const OptionsDialogContext = createContext<OptionsDialogProps | undefined>(undefined)

interface OptionsDialogProviderProps {
  children: ReactNode
}

export const OptionsDialogProvider = (props: OptionsDialogProviderProps) => {

  const [ title, setTitle ] = useState<string>('')
  const [ showDialog, setShowDialog ] = useState<boolean>(false)
  const [ closeButton, setCloseButton ] = useState(false)
  const [ options, setOptions ] = useState<OptionsDialogOptions[]>([])

  const showOptionsDialog = (title: string, options: OptionsDialogOptions[]) => {

    setTitle(title)
    setOptions(options)

    setShowDialog(true)
  }

  const hideOptionsDialog = () => {

    setShowDialog(false)
  }

  const value: OptionsDialogProps = {
    isOpen: showDialog,
    show: showOptionsDialog,
    hide: hideOptionsDialog,
  }

  return (
    <OptionsDialogContext.Provider value={value}>
      {props.children}

      <OptionsDialog
        show={showDialog}
        title={title}
        closeButton={closeButton}
        onHide={hideOptionsDialog}
        options={options}
      />
    </OptionsDialogContext.Provider>
  )
}

export const useOptionsDialog = () => {

  const context = useContext(OptionsDialogContext)

  if (context === undefined) {
    throw new Error('useOptionsDialog must be used within a OptionsDialogProvider')
  }

  return context
}
